import * as React from "react";
import { CurrentPdfProvider } from "@/contexts/setPdfContext";
import { ChronologyTimelines } from "@/views/chronology/components/timelines";

export const ChronologyView: React.FC = () => (
  <CurrentPdfProvider>
    <div className="flex h-[95vh]">
      <ChronologyTimelines />
    </div>
  </CurrentPdfProvider>
);
